(function () {

    'use strict';
    angular.module('app')
        .controller('marketingFrameController', ['$scope', '$location', '$routeParams', '$sce', marketingFrameController]
            );

    function marketingFrameController($scope, $location, $routeParams, $sce) {
        $scope.model = {};
        $scope.model.hideframe = false;
        switch ($location.url().toLowerCase()) {
            case '/home'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://www.communigator.co.uk/customer-portal/');
                break;
            case '/SignUp/GatorMail'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://tools.spotler.co.uk/GatorMail');
                break;
            case '/SignUp/GatorExpress'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://www.communigator.co.uk/GatorExpress/GatorExpress.html');
                break;
            case '/SignUp/GatorWorkflow'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://tools.spotler.co.uk/GatorWorkflow');
                break;
            case '/SignUp/GatorLeads'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://tools.spotler.co.uk/GatorLeads');
                break;
            case '/SignUp/GatorDocs'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://www.communigator.co.uk/GatorDocs/GatorDocs.html');
                break;
            case '/SignUp/GatorSocial'.toLowerCase():
                $scope.model.src = '';
                window.location = '/SocialWizard';
                break;
            case '/SignUp/GatorSurvey'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://tools.spotler.co.uk/GatorSurvey');
                break;
            case '/SignUp/GatorSendforensics'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://www.communigator.co.uk/SendForensics/SendForensics.html');
                break;
            case '/SignUp/GatorPopup'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://tools.spotler.co.uk/GatorPopup');
            case '/SignUp/GatorReport'.toLowerCase():
                $scope.model.src = $sce
                    .trustAsResourceUrl('https://www.communigator.co.uk/GatorPopup/GatorPopup.html');
                
                break; 

        }
    }
})();

